import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon, } from '../Icon';
const buttonStyles = css `
  ${styleUtils.buttonReset}
  ${styleUtils.borderBox}
  align-items: center;
  aspect-ratio: 1/1;
  background-color: ${theme.colors.gray200};
  border: none;
  color: ${theme.colors.gray700};
  display: inline-flex;
  flex-direction: column;
  height: auto;
  justify-content: center;
  padding-bottom: ${theme.spacing.x4};
  padding-left: 0;
  padding-right: 0;
  padding-top: ${theme.spacing.x4};
  text-decoration: none;
  width: 100%;

  &:hover {
    background-color: ${theme.colors.gray300};
  }
`;
const buttonTextStyles = css `
  ${theme.typeStyles.captionSmallStyles}
`;
const iconContainerStyles = css `
  padding-bottom: ${theme.spacing.base};
`;
const ContextualButton = (props) => {
    const { ariaDescribedBy, ariaLabel, ariaLabelledBy, ariaPressed, disabled, iconType, text, type, } = props;
    return type === 'file'
        ? (_jsxs("label", Object.assign({ css: buttonStyles, htmlFor: props.id }, { children: [iconType && (_jsx("span", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { size: "medium", type: iconType }) }))), _jsx("span", Object.assign({ css: buttonTextStyles }, { children: text })), _jsx("input", { accept: props.accept, "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, css: styleUtils.visuallyHidden, disabled: disabled, id: props.id, multiple: props.multiple, onBlur: props.onBlur, onChange: props.onChange, onClick: props.onClick, onFocus: props.onFocus, onKeyDown: props.onKeyDown, onKeyUp: props.onKeyUp, onMouseDown: props.onMouseDown, onMouseLeave: props.onMouseLeave, onMouseUp: props.onMouseUp, onTouchEnd: props.onTouchEnd, onTouchMove: props.onTouchMove, onTouchStart: props.onTouchStart, type: "file" })] })))
        : (_jsxs("button", Object.assign({ "aria-describedby": ariaDescribedBy, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-pressed": ariaPressed, css: buttonStyles, disabled: disabled, onBlur: props.onBlur, onClick: props.onClick, onFocus: props.onFocus, onKeyDown: props.onKeyDown, onKeyUp: props.onKeyUp, onMouseDown: props.onMouseDown, onMouseLeave: props.onMouseLeave, onMouseUp: props.onMouseUp, onTouchEnd: props.onTouchEnd, onTouchMove: props.onTouchMove, onTouchStart: props.onTouchStart, type: "button" }, { children: [iconType && (_jsx("span", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { size: "medium", type: iconType }) }))), _jsx("span", Object.assign({ css: buttonTextStyles }, { children: text }))] })));
};
const MemoizedContextualButton = memo(ContextualButton);
export { MemoizedContextualButton as ContextualButton };
// MC-1068 Temporary hack for Storybook.
export default ContextualButton;
